module.exports = __webpack_public_path__ + "static/img/27@2x.e124ec18.png";